import React, { FC, useMemo } from 'react';

import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { ContentItemListBlock, ContentItemType, Orientation } from '../../types';
import { VideosBlock } from '../VideosBlock';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      '& .swiper-container': {
        [theme.breakpoints.up('md')]: {
          paddingTop: 35,
        },
      },
    },
  });
});

interface ContentListBlockProps {
  data?: ContentItemListBlock | null;
  withArrows?: boolean;
  classes?: {
    wrapper?: string;
    container?: string;
    heading?: string;
    videoWrapper?: string;
  };
  titleToLeft?: boolean;
  loading?: boolean;
  wrapperId?: string;
  withChunksOnMobile?: boolean;
}

const ContentListBlock: FC<ContentListBlockProps> = ({ data, ...rest }) => {
  const classes = useStyles();

  const formattedData = useMemo(() => {
    return {
      ...data,
      orientation: Orientation.Lanscape,
      items: data?.content_items?.map((item) => ({
        type: item?.type,
        ranking: item?.ranking,
        ...(item?.type === ContentItemType.Video && {
          video: item?.entity,
        }),
        ...(item?.type === ContentItemType.Pathway && {
          pathway: item?.entity,
        }),
      })),
    };
  }, [data]);

  return (
    <VideosBlock
      data={formattedData}
      classes={{
        wrapper: classes.wrapper,
      }}
      {...rest}
    />
  );
};

export default ContentListBlock;
